import { AdvancedAnalysis } from "../models/AdvancedAnalysis";
import { AdvancedAnalysisField } from "../models/AdvancedAnalysisField";
import { AdvancedAnalysisSchema } from "../models/AdvancedAnalysisSchema";



export class AdvancedAnalysisTypeGuardService {

    private static readonly ADVANCED_ANALYSIS_TYPES_THAT_SUPPORT_CHILD_RULES = [];

    public static isAdvancedAnalaysis(obj: unknown): obj is AdvancedAnalysis {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            '_type' in obj &&
            typeof (obj as any)._type === 'string'
        );
    }

    public static isAdvancedAnalaysisField(obj: unknown): obj is AdvancedAnalysisField {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'name' in obj &&
            'field_type' in obj &&
            typeof (obj as any).name === 'string' &&
            typeof (obj as any).field_type === 'string'
        );
    }

    public static isAdvancedAnalaysisSchema(obj: unknown): obj is AdvancedAnalysisSchema {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'type' in obj &&
            'display_name' in obj &&
            'fields' in obj &&
            typeof (obj as any).type === 'string' &&
            typeof (obj as any).display_name === 'string' &&
            Array.isArray((obj as any).fields)
        );
    }

    public static hasDefinedAdvancedAnalysisSchemaUi(advancedAnalysisSchema: AdvancedAnalysisSchema): boolean {
        return this.isAdvancedAnalaysisSchema(advancedAnalysisSchema)
            && advancedAnalysisSchema.ui != null
            && typeof advancedAnalysisSchema.ui === 'object'
            && Array.isArray(advancedAnalysisSchema.ui.field_groups)
            && advancedAnalysisSchema.ui.field_groups.length > 0
            && advancedAnalysisSchema.ui.field_groups.every(group =>
                group != null
                && typeof group === 'object'
                && Array.isArray(group.fields)
                && group.fields.length > 0
            );
    }

    //@ts-ignore
    public static supportsChildAdvancedAnalyses(obj: unknown): boolean {
        return false;
    }

    public static isPayloadTemplateAdvancedAnaylsisSchema(obj: unknown): boolean {
        return this.isAdvancedAnalaysisSchema(obj) && (obj as AdvancedAnalysisSchema).payload_template != null;
    }

    public static advancedAnalysisTypeSupportsChildAdvancedAnalyses(advancedAnalysisType?: string): boolean {
        return this.ADVANCED_ANALYSIS_TYPES_THAT_SUPPORT_CHILD_RULES.find(x => advancedAnalysisType === x) != null;
    }

    public static isNonEmptyAdvancedAnalysisObject(value: unknown): value is Record<string, unknown> {
        return (
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value) &&
            Object.keys(value).length > 0
        )
    }

    public static isUnflattenedAdvancedAnalysis(value: unknown): value is AdvancedAnalysis {
        return (
            typeof value === 'object' &&
            value !== null &&
            '_type' in value &&
            typeof (value as any)._type === 'string' &&
            'configuration' in value &&
            typeof (value as any).configuration === 'object' &&
            (value as any).configuration !== null
        );
    }

}